export const presentationList = [
  {
    image: "assets/images/fiscabox_back.jpg",
    title: "Professional pricing",
    content:
      "Plateforme gratuite, faible commissions. MoranjETrade est une puissance de technologies de négociation avancées conçues pour aider les Utilisateurs à obtenir la meilleure exécution et à maximiser l’amélioration des prix.",
  },
  {
    image: "assets/images/fiscabox_back.jpg",
    title: "Strength and security",
    content:
      "Lorsque vous confiez votre argent à un courtier, vous devez vous assurer qu'il est sûr et qu'il peut résister aux bonnes comme aux mauvaises périodes. Notre forte position en capital, notre bilan conservateur et nos contrôles de risque automatisés sont conçus.",
  },
  {
    image: "assets/images/fiscabox_back.jpg",
    title: "Global access",
    content:
      "Investissez en Afrique dans des obligations, à partir d'une plateforme unique et unifiée. Approvisionnez votre compte dans plusieurs devises et négociez des actifs libellés dans plusieurs devises en Afrique. Accédez aux données du marché 24 ",
  },
  {
    image: "assets/images/fiscabox_back.jpg",
    title: "Technologie",
    content:
      "La puissante suite technologique de MoranjETrade  vous aide à optimiser la vitesse et l'efficacité de vos transactions et à effectuer des analyses de portefeuille.",
  },
  // {
  //   image: 'assets/images/fiscabox_back.jpg',
  //   title: 'Global access',
  //   content:
  //     "Vous disposez d'un ensemble de forfait mis à votre disposition, à des prix abordables, qui répondent chacun.",
  // },
];

export const SECTION_1 = [
  "Gratuite, rapide et facile à utiliser",
  "Sécurisé",
  "Accès en temps réel aux informations financières et du marché",
  "Accès en temps réel aux offres et demandes",
  "Outils d'analyse avancés pour une meilleure prise du décision",
];

export const SERVICES = [
  {
    title: "Courtage d'obligation",
    content:
      "Explication du processus, des avantages pour les investisseurs et les émetteurs.",
  },
  {
    title: "Services d'intermédiation",
    content:
      "Comment l'application met en relation les investisseurs avec les émetteurs d'obligations, les avantages pour chaque partie.",
  },
  {
    title: "Outils et ressources",
    content:
      "Informations sur les outils analytiques, les rapports de marché etc.",
  } 
];
